export interface SearchFeatureOption {
    value: any;
    label: string;
    img: string;
}

export class SearchFeatureOptionsHelper {
    static create(): SearchFeatureOption {
        return {
            value: '',
            label: '',
            img: '',
        };
    }

    static transformFromApi(apiData: Object): SearchFeatureOption {
        const searchFeature = SearchFeatureOptionsHelper.create();
        searchFeature.value = apiData['VALOR'] ? apiData['VALOR'].trim() : '';
        searchFeature.label = apiData['VALOR_MOSTRAR'] ? apiData['VALOR_MOSTRAR'].trim() : '';

        return searchFeature;
    }
}
